var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPublish = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.307 6.505c-.74-2.468 1.77-4.66 4.115-3.593l13.986 6.357c2.345 1.066 2.345 4.396 0 5.462L6.422 21.088c-2.345 1.066-4.855-1.125-4.115-3.593l1.563-5.208a1 1 0 0 0 0-.574zm3.288-1.773c-.782-.355-1.619.376-1.372 1.198l1.562 5.208a3 3 0 0 1 0 1.724L4.223 18.07c-.247.822.59 1.553 1.372 1.198L19.58 12.91c.781-.355.781-1.465 0-1.82z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4 12a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})));
export default SvgIcPublish;